module.exports = __webpack_public_path__ + "static/backdrop-af868a241def97033a7d3b2e9a80c8d0.png";